<template>
  <div class="ms-powerpoint-page container py-4">
    <!-- Page Heading -->
    <h2 class="mb-4">MS PowerPoint</h2>

    <!-- Description / Introduction -->
    <p>
      MS PowerPoint is a presentation software used to create slideshows for meetings, lectures, and events.
      It allows you to combine text, images, videos, charts, and animations into professional presentations.
    </p>

    <!-- Example Features List -->
    <h5 class="mt-4">Key Features of MS PowerPoint:</h5>
    <ul>
      <li>Creating and designing slides with themes and templates</li>
      <li>Adding text, images, charts, and multimedia</li>
      <li>Using animations and slide transitions</li>
      <li>Collaborating with others in real-time</li>
      <li>Presenter view and slideshow tools for delivery</li>
    </ul>

    <!-- Example Image / Screenshot -->
    <div class="mt-4 text-center">
      <img
        src="@/assets/Tutorials/MSOffice/ms-powerpoint.png"
        alt="MS PowerPoint Example"
        class="img-fluid rounded shadow-sm"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "MsPowerpoint",
};
</script>

<style scoped>
h2 {
  color: #d97706; /* Orange heading for PowerPoint */
  font-weight: 700;
}

ul {
  list-style-type: disc;
  margin-left: 20px;
}

p {
  font-size: 1rem;
  line-height: 1.6;
  color: #374151;
}

img {
  max-width: 100%;
  height: auto;
}
</style>
